import { render } from "./DialogMezzo.vue?vue&type=template&id=01ba8c1c"
import script from "./DialogMezzo.vue?vue&type=script&lang=js"
export * from "./DialogMezzo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__